import { useParams } from 'react-router-dom';
import { ORGANISATION_ID_PARAM } from '../Utils/NavigationUtils';
export default function useOrganisationId() {
    const params = useParams();
    return params[ORGANISATION_ID_PARAM];
}
export function useRequiredOrganisationId() {
    const orgranisationId = useOrganisationId();
    if (!orgranisationId) {
        throw new Error('Could not find required organisation id from route');
    }
    return orgranisationId;
}
//# sourceMappingURL=UseOrganisationId.js.map